import { Grid, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { Link as RouterLink, Outlet, useNavigate } from "react-router-dom"
import { LanguageSelector } from "../../../shared/components/languageSelector/LanguageSelector"
import { LOGIN_ROUTE } from "../../../constants/routes"
import FacilitynetLogo from "../assets/facilitynet-logo-text-only-black-no-bg.svg"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarCheck } from "@fortawesome/pro-regular-svg-icons"
import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons"

const useStyles = makeStyles()((theme) => ({
    root: {
        height: "100vh",
        flexWrap: "nowrap",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        [theme.breakpoints.down(800)]: {
            display: "none",
        },
    },
    logo: {
        width: "10rem",
    },
    logoLink: {
        padding: "0.5rem",
        display: "flex",
        alignItems: "center",
    },
    leftSide: {
        flex: "1 1",
        display: "flex",
        flexDirection: "column",
        padding: "2rem",
        backgroundColor: "#fff",
    },
    rightSide: {
        flex: "1 1",
        background: "linear-gradient(181deg,rgba(62, 74, 111, 1) 0%, rgba(50, 112, 234, 1) 100%)",
        padding: "2rem",
        [theme.breakpoints.down(800)]: {
            display: "none",
        },
    },
    rightContent: {
        height: "100%",
    },
    rightTitleArea: {
        gap: "1.5rem",
        width: "70%",
    },
    title: {
        fontSize: "2.5rem",
        lineHeight: "1.1",
        [theme.breakpoints.down(1200)]: {
            fontSize: "1.5rem",
        },
        [theme.breakpoints.down(1000)]: {
            fontSize: "1rem",
        },
    },
    calendarIcon: {
        color: "white",
    },
    backButton: {
        display: "none",
        paddingBottom: "1.75rem",
        [theme.breakpoints.down(800)]: {
            display: "block",
        },
    },
}))

type SignInLayoutProps = {}

export function LoginLayout({}: SignInLayoutProps) {
    const { classes } = useStyles()
    const navigate = useNavigate()

    return (
        <Grid container component="main" className={classes.root}>
            <Grid item className={classes.leftSide}>
                <Grid container justifyContent="space-between" className={classes.header}>
                    <RouterLink className={classes.logoLink} to={LOGIN_ROUTE}>
                        <img className={classes.logo} src={FacilitynetLogo} alt="Facilitynet" />
                    </RouterLink>
                    <LanguageSelector color="black" />
                </Grid>
                <Grid container>
                    <FontAwesomeIcon icon={faChevronLeft} className={classes.backButton} onClick={() => navigate(-1)} />
                </Grid>

                <Outlet />
            </Grid>

            <Grid item className={classes.rightSide}>
                <Stack
                    direction="column"
                    flexWrap="nowrap"
                    justifyContent="center"
                    alignItems="center"
                    className={classes.rightContent}
                >
                    <Stack
                        direction="column"
                        flexWrap="nowrap"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        className={classes.rightTitleArea}
                    >
                        <FontAwesomeIcon icon={faCalendarCheck} size="5x" className={classes.calendarIcon} />
                        <LocalizedStrict id="start-page-layout-title">
                            <Typography color={"#fff"} variant="h6" className={classes.title}>
                                Easy Canteen Management
                            </Typography>
                        </LocalizedStrict>
                    </Stack>
                </Stack>
            </Grid>
        </Grid>
    )
}
